import {HttpClient} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {environment} from '../../../assets/environments/environment';
import {ContractModeEnum} from '../../activity-report/models/contract-mode.enum';


@Injectable({
  providedIn: 'root'
})
export class KpisService {
  private _updatedSubscription: EventEmitter<null> = new EventEmitter();
  constructor(private httpClient: HttpClient) {}

  private submittedFeeCount: number | null = null;
  private submittedOnCallCount: number | null = null;
  private submittedActivitySheetCount: number | null = null;
  private duePaymentsPending: { [key: string]: number } = {};

  getSubmittedFeeCount(force: boolean = false): Observable<number> {
    if (!this.submittedFeeCount || force) {
      return this.httpClient.get<number>(environment.api_root + 'activityReportMgtApi/kpis/fee').pipe(
        tap(data => this.submittedFeeCount = data),
      );
    }
    return of(this.submittedFeeCount);
  }

  getSubmittedOnCallCount(force: boolean = false): Observable<number> {
    if (!this.submittedOnCallCount || force) {
      return this.httpClient.get<number>(environment.api_root + 'activityReportMgtApi/kpis/on-calls').pipe(
        tap(data => this.submittedOnCallCount = data),
      );
    }
    return of(this.submittedOnCallCount);
  }

  getSubmittedActivitySheetCount(force: boolean = false): Observable<number> {
    if (!this.submittedActivitySheetCount || force) {
      return this.httpClient.get<number>(environment.api_root + 'activityReportMgtApi/kpis/activity-sheet').pipe(
        tap(data => this.submittedActivitySheetCount = data),
      );
    }
    return of(this.submittedActivitySheetCount);
  }

  getDuePaymentsPending(contractModeEnum: ContractModeEnum, force: boolean = false): Observable<number> {
    if (!this.duePaymentsPending[contractModeEnum] || force) {
      return this.httpClient.get<number>(environment.api_root + 'requestMgtApi/kpis/due-payments/pending?contractModeEnum=' + contractModeEnum).pipe(
        tap(data => this.duePaymentsPending[contractModeEnum] = data),
      );
    }
    return of(this.duePaymentsPending[contractModeEnum]);
  }

  getUpdatedSubscription(): EventEmitter<null> {
    return this._updatedSubscription;
  }
}
